// ante-react-kit/src/components/v2/hooks/useAutoReload.js
import { useRef, useCallback } from 'react';

const BACKOFF_SCHEDULE = [3000, 6000, 12000, 24000, 30000]; // ms
const MAX_RETRIES = BACKOFF_SCHEDULE.length;

export default function useAutoReload(loadContentRef, lockRef, mountedRef) {
    // loadContentRef: ref chứa loadContent function (tránh stale closure)
    // lockRef: ref chứa { saving: bool, loading: bool }
    // mountedRef: ref boolean — false sau unmount

    var timerRef = useRef(null);
    var retryCountRef = useRef(0);

    var stop = useCallback(function stopAutoReload() {
        if (timerRef.current) {
            clearTimeout(timerRef.current);
            timerRef.current = null;
        }
        retryCountRef.current = 0;
    }, []);

    var scheduleNext = useCallback(function scheduleNextReload() {
        if (!mountedRef.current) return;
        if (retryCountRef.current >= MAX_RETRIES) {
            stop();
            return;
        }

        var delay = BACKOFF_SCHEDULE[retryCountRef.current] || 30000;
        timerRef.current = setTimeout(async function autoReloadTick() {
            if (!mountedRef.current) return;
            if (lockRef.current.saving || lockRef.current.loading) {
                // Đang busy → thử lại sau cùng delay
                scheduleNext();
                return;
            }

            try {
                if (loadContentRef.current) {
                    await loadContentRef.current({ isAutoReload: true });
                }
            } catch (e) {
                // Swallow — loadContent tự handle error
            }

            retryCountRef.current++;
            scheduleNext();
        }, delay);
    }, [stop, loadContentRef, lockRef, mountedRef]);

    var start = useCallback(function startAutoReload(loadNow) {
        stop();
        retryCountRef.current = 0;

        if (loadNow && loadContentRef.current) {
            // Load ngay, sau đó bắt đầu backoff
            Promise.resolve().then(function () {
                if (mountedRef.current && loadContentRef.current) {
                    loadContentRef.current({ isAutoReload: true }).catch(function () {});
                }
            });
        }

        scheduleNext();
    }, [stop, scheduleNext, loadContentRef, mountedRef]);

    var restart = useCallback(function restartAutoReload() {
        // Reset counter, bắt đầu lại từ 3s
        stop();
        retryCountRef.current = 0;
        scheduleNext();
    }, [stop, scheduleNext]);

    return { start: start, stop: stop, restart: restart };
}
